import Image from "next/image";
import Check from "@/icons/status/seal-check-v2.svg";

const AuthorInfo = ({ photo, author, photoAlt }: { photo?: string; author: string; photoAlt?: string }) => (
    <div className="flex items-center gap-[10px]">
        {photo && (
            <div className="relative w-10 h-10 rounded-full overflow-hidden">
                <Image
                    src={photo}
                    alt={photoAlt ?? author}
                    width={40}
                    height={40}
                    className="absolute top-0 left-0 w-full h-full object-cover object-center"
                />
            </div>
        )}
        <div className="font-suisseBP">
            <h3 className="text-[16px] leading-[1.25] tracking-[1.28px] uppercase">
                {author}
            </h3>
            <p className="flex items-center justify-center gap-1 text-[10px] leading-[1.4] tracking-[0.8px] uppercase">
                <Check />
                <span className="inline-block text-gray400 pt-[2px]">VERIFIED PATIENT</span>
            </p>
        </div>
    </div>
);

export default AuthorInfo;
